import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Pack\ReorderPacksController::__invoke
* @see app/Http/Controllers/Pack/ReorderPacksController.php
* @route '/api/pack/reorder'
*/
const ReorderPacksController = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderPacksController.url(options),
    method: 'put',
})

ReorderPacksController.definition = {
    methods: ["put"],
    url: '/api/pack/reorder',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Pack\ReorderPacksController::__invoke
* @see app/Http/Controllers/Pack/ReorderPacksController.php
* @route '/api/pack/reorder'
*/
ReorderPacksController.url = (options?: RouteQueryOptions) => {
    return ReorderPacksController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Pack\ReorderPacksController::__invoke
* @see app/Http/Controllers/Pack/ReorderPacksController.php
* @route '/api/pack/reorder'
*/
ReorderPacksController.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: ReorderPacksController.url(options),
    method: 'put',
})

export default ReorderPacksController